<template>
  <sec-page :faq="FAQS.baseline.items">
    <sec-hero centered :eyebrow="b.hero.eyebrow" :title="b.hero.title" :lede="b.hero.lede" />

    <sec-section>
      <sec-section-heading :eyebrow="b.distribution.eyebrow" :title="b.distribution.title" />
      <sec-domain-grid show-count />
    </sec-section>

    <sec-section>
      <sec-section-heading :eyebrow="b.fourControls.eyebrow" :title="b.fourControls.title" />
      <sec-data-table :columns="b.fourControls.columns" :rows="b.fourControls.rows" />
      <p class="m500 sec-body" data-reveal>{{ b.fourControls.closing }}</p>
    </sec-section>

    <not-certification-section />

    <sec-section labelledby="faq-baseline" :divider="false">
      <sec-faq
        heading-id="faq-baseline"
        :eyebrow="FAQS.baseline.eyebrow"
        :title="FAQS.baseline.title"
        :items="FAQS.baseline.items"
      />
    </sec-section>
    <get-in-touch-section heading-id="baseline-get-in-touch" />
  </sec-page>
</template>

<script setup>
// DIGU AI Security Baseline v1.0: 32 controls in five domains.
import SecPage from '@/components/security/ui/SecPage.vue';
import SecHero from '@/components/security/ui/SecHero.vue';
import SecSection from '@/components/security/ui/SecSection.vue';
import SecSectionHeading from '@/components/security/ui/SecSectionHeading.vue';
import SecDomainGrid from '@/components/security/ui/SecDomainGrid.vue';
import SecDataTable from '@/components/security/ui/SecDataTable.vue';
import SecFaq from '@/components/security/ui/SecFaq.vue';
import GetInTouchSection from '../shared/GetInTouchSection.vue';
import NotCertificationSection from './Sections/NotCertificationSection.vue';
import { BASELINE } from '@/content/security/baseline';
import { FAQS } from '@/content/security/faqs';

const b = BASELINE;
</script>
